import { type RootState, useAppSelector } from 'api/redux'
import { TrinityButton } from 'components/trinity-button'
import { useTranslation } from 'react-i18next'
import { LabelType } from 'types'
import { checkIfLabelIsEnabled } from 'utils/printconfig'
import { type ApiHandlerContext } from 'utils/useApiHandler'

interface ActionButtonsProps {
  isManualInput: boolean
  onSwapScreens: () => void
  printLabelContext: ApiHandlerContext<any>
}

export const ActionButtons = ({
  isManualInput,
  onSwapScreens,
  printLabelContext
}: ActionButtonsProps) => {
  const { t } = useTranslation()
  const printConfig = useAppSelector((state: RootState) => state.application.printConfig)
  return (
    <div className='absolute top-0 right-0'>
        <TrinityButton
            onClick={onSwapScreens}
            className={'mr-3'}
        >
            {isManualInput ? t('scan_unit.scan_upc.title') : t('scan_unit.manual_entry.title')}
        </TrinityButton>
        {checkIfLabelIsEnabled(printConfig, LabelType.BlindILPN) && (
            <TrinityButton
                loading={printLabelContext.isLoading}
                onClick={() => { printLabelContext.handleApiCall(LabelType.BlindILPN) }}
            >
                {t('buttons.printing.label', { labelType: t('buttons.printing.blind_lpn_label') })}
            </TrinityButton>
        )}
    </div>
  )
}
